module.exports = __webpack_public_path__ + "img/baitiao_phoneRecharge.f5c42a8a.png";